import angular from 'angular';
import uiRouter from 'angular-ui-router';
import receiptComponent from './receipt.component';
import paymentItemComponent from '../payment-item/payment-item.component';
import ngMessages from 'angular-messages';

let receiptModule = angular.module('giReceipt', [
    uiRouter,
    ngMessages
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newGIReceipt', {
            url: '/receipts/gi/new?groupInvoiceId&clientId',
            component: 'giReceipt',
            parent: 'main',
            data: {
                permissions: {
                    only: ['OPERATOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                user: (LoginService) => {
                    return LoginService.getCurrent();
                },
                groupInvoice: (GroupInvoicesService, $stateParams) => {
                    if ($stateParams.groupInvoiceId) {
                        return GroupInvoicesService.findById(
                            $stateParams.groupInvoiceId,
                            {
                                include: ['quotes', 'client']
                            }
                        );
                    }
                },
                client: (ClientsService, $stateParams) => {
                    return ClientsService.findById($stateParams.clientId);
                },
                groupInvoices: (GroupInvoicesService, $stateParams) => {
                    if ($stateParams.clientId) {
                        return GroupInvoicesService.find({
                                where: {
                                    clientId: $stateParams.clientId,
                                    status: 'invoiced',
                                    ...($stateParams.groupInvoiceId ? {
                                        id: {
                                            neq: $stateParams.groupInvoiceId
                                        }
                                    }: null)
                                },
                                include: ['quotes', 'client'],
                                order: 'createdAt DESC'
                        });
                    }
                }
            }
        })
        .state('editGIReceipt', {
            url: '/receipts/gi/:id',
            component: 'giReceipt',
            parent: 'main',
            data: {
                permissions: {
                    only: ['OPERATOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                user: (LoginService) => {
                    return LoginService.getCurrent();
                },
                receipt: (ReceiptsService, $stateParams) => {
                    return ReceiptsService.findOne({
                        filter: {
                            where: {
                                id: $stateParams.id
                            },
                            include: [
                                {
                                    relation: 'client'
                                },
                                {
                                    relation: 'groupInvoices',
                                    scope: {
                                        include: [{
                                            relation: 'receiptGroupInvoices',
                                            scope: {
                                                where: {
                                                    receiptId: $stateParams.id
                                                }
                                            }
                                        }],
                                    }
                                },
                                {
                                    relation: 'paymentItems',
                                    scope: {
                                        include: [{
                                            relation: 'check',
                                            scope: {
                                                deleted: true
                                            }
                                        },{
                                            relation:  'bankTx',
                                            scope: {
                                                deleted: true
                                            }
                                        }],
                                        deleted: true
                                    }
                                },
                                'employee'
                            ],
                            deleted: true
                        }
                    });
                }
            }
        });
})
    .component('giReceipt', receiptComponent)
    .component('giReceiptPaymentItem', paymentItemComponent)
    .name;

export default receiptModule;
